import styled, { css } from "styled-components";

export const SidebarMenuWrapper = styled.div`
	display: none;
	padding: 65px 10px 20px 10px;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;
	flex: 1 0 0;
	align-self: stretch;
	border-radius: 20px;

	@media (min-width: 1280px) {
		display: flex;
		min-width: 202px;
	}
`;

export const LinkWrapper = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: center;
	align-items: center;
	gap: 5px;

	img {
		width: 30px;
	}

	${({ isActive }) =>
		isActive
			? css`
					svg {
						path {
							fill: #eff0f6;
						}
					}
				`
			: css`
					svg {
						path {
							fill: #6e7191;
						}
					}
				`}

	a {
		color: #6e7191;
		text-align: start;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.75px;
	}

	.active-link {
		color: #eff0f6;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.75px;
	}
`;
